__turbopack_context__.v({
  "brandItem": "BrandsExpandable-module__KY00Na__brandItem",
  "brandName": "BrandsExpandable-module__KY00Na__brandName",
  "description": "BrandsExpandable-module__KY00Na__description",
  "desktopGrid": "BrandsExpandable-module__KY00Na__desktopGrid",
  "extraGrid": "BrandsExpandable-module__KY00Na__extraGrid",
  "grid": "BrandsExpandable-module__KY00Na__grid",
  "heading": "BrandsExpandable-module__KY00Na__heading",
  "imageContainer": "BrandsExpandable-module__KY00Na__imageContainer",
  "mobileScroller": "BrandsExpandable-module__KY00Na__mobileScroller",
  "scrollTrack": "BrandsExpandable-module__KY00Na__scrollTrack",
  "toggleButton": "BrandsExpandable-module__KY00Na__toggleButton",
  "toggleIcon": "BrandsExpandable-module__KY00Na__toggleIcon",
  "wrapper": "BrandsExpandable-module__KY00Na__wrapper",
});
